import request from '@/api/http.js'

//下载pdf文件
export function publicPdf(query) {
    return request({
        url: `public/pdf`,
        method: 'get',
        params: query,
        responseType: 'blob'
    })
}

// 公开单位
export function publicDivs(query) {
    return request({
        url: 'public/divs',
        method: 'get',
        params: query,
    })
}

// 公开单位详情
export function publicDiv(query) {
    return request({
        url: 'public/div',
        method: 'get',
        params: query,
    })
}
// 公开地区详情
export function getPublic(query) {
    return request({
        url: 'public',
        method: 'get',
        params: query,
    })
}